<template>
    <BasePanel>
        <template #title>
            Word lid en ga
            {{
                ticketPricing.needsPayment && ticketPricing.parsedPrice
                    ? ` voor €${ticketPricing.parsedPrice}`
                    : ' gratis'
            }}
        </template>

        <template #default>
            <p>
                Ga onbeperkt vanaf €15 p/m,<br>
                500+ programma’s per maand
            </p>

            <p>
                <BaseButton
                    :to="`/${SIGNUP_URL}`"
                    :element="NuxtLink"
                    class="button--secondary button--stretch"
                >
                    Word lid
                </BaseButton>
            </p>

            <p v-if="!loggedIn">
                Ben je al lid?

                <a @click.prevent="openLoginModal">
                    Login
                </a>
            </p>
        </template>
    </BasePanel>
</template>

<script setup lang="ts">
import { SIGNUP_URL } from '~/constants/membership';

defineProps<{
    event: EventDate;
}>();

const eventsStore = useEventsStore();
const { ticketPricing } = storeToRefs(eventsStore);

const modalStore = useModalStore();
const { loggedIn } = storeToRefs(useUserStore());

const NuxtLink = resolveComponent('NuxtLink');

const openLoginModal = () => {
    modalStore.closeAll();
    modalStore.open(MODAL_LOGIN);
};
</script>

<style lang="css" scoped>
a:not([href]) { cursor: pointer; }
</style>
